import { Card, CardBody } from '@chakra-ui/react';
import { TradingFloor } from 'components';
import { useAuth } from 'contexts/AuthContext';
import { useActiveMarket } from 'hooks/queries/useActiveMarket';
import { useNavigate } from 'react-router-dom';
import { NavigationService } from 'services';

export default function DashboardTradingFloorCard() {
  const { currentUser } = useAuth();
  const { data: activeMarket, isLoading } = useActiveMarket();
  const navigate = useNavigate();

  const handleItemNameClick = (itemId: string, itemName: string) => {
    navigate(NavigationService.getItemDetailsPath(itemId, itemName));
  };

  const handleArtistNameClick = (artistId: string, artistName: string) => {
    navigate(NavigationService.getArtistDetailsPath(artistId, artistName));
  };

  return (
    <Card w="100%">
      <CardBody>
        <TradingFloor
          bids={activeMarket?.bids || []}
          asks={activeMarket?.asks || []}
          user={currentUser}
          showSearchFilter
          isLoading={isLoading}
          onItemNameClick={handleItemNameClick}
          onItemArtistNameClick={handleArtistNameClick}
        />
      </CardBody>
    </Card>
  );
}
